import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils';

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding: 15px 0px;

  hr {
    height: ${props => props.height};
    width: 100%;
    background-color: ${props => props.color};
    border-radius: 0.9px;
    border: 0;
    margin: 0;
  }

  span {
    margin: 0px 10px;
    font-weight: bold;
    color: ${props => props.color};
  }
`;

function LineDivider({ children, height, color }) {
  return (
    <Container height={height} color={color}>
      <hr />
      {children && <span>{children}</span>}
      <hr />
    </Container>
  );
}

LineDivider.defaultProps = {
  children: '',
  color: colors.g02,
  height: '1.5px'
};

LineDivider.propTypes = {
  children: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string
};

export { LineDivider };
